<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3 class="font-weight-bold">
                {{
                  isDeletePage()
                    ? "Deleted Room Notifications"
                    : "Room Notifications"
                }}
              </h3>
              <template v-if="!isDeletePage()">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/room-notifications/create"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ..."
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.room_id"
                    :items="rooms"
                    item-text="name"
                    item-value="id"
                    label="Filter by Room"
                    clearable
                    prepend-inner-icon="mdi-door"
                    @change="
                      page = 1;
                      getData();
                    "
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>&nbsp; Sr. No.</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: none">Sent By</th>
                      <th class="text-left" style="min-width: none">Room</th>
                      <th class="text-left" style="min-width: none">Title</th>
                      <th class="text-left" style="min-width: none">Message</th>
                    </tr>
                  </thead>
                  <tbody v-if="notifications.length">
                    <tr
                      v-for="(notification, i) in notifications"
                      :key="`notification_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': notifications.length - 1 == i,
                      }"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        <v-chip
                          small
                          :color="notification.is_active ? 'teal' : 'red'"
                          text-color="white"
                        >
                          <v-icon left small>{{
                            notification.is_active
                              ? "mdi-checkbox-marked-circle"
                              : "mdi-close-circle"
                          }}</v-icon>
                          {{ notification.is_active ? "Active" : "Inactive" }}
                        </v-chip>
                      </td>
                      <td>{{ notification.sender?.first_name || "N/A" }}</td>
                      <td>{{ notification.room?.name || "N/A" }}</td>
                      <td>{{ notification.title }}</td>
                      <td>{{ notification.message }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="5" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination
                v-model="page"
                :length="paginationLength"
                rounded
              ></v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        room_id: null,
      },
      notifications: [],
      statuses: [
        { text: "ACTIVE", value: "1" },
        { text: "INACTIVE", value: "0" },
      ],
      rooms: [],
      page: 1,
      paginationLength: 0,
      isLoading: false,
      rowsPerPage: 10,
    };
  },
  mounted() {
    this.getRooms();
    this.getData();
  },
  methods: {
    isDeletePage() {
      return this.$route.query.open_trash === "1";
    },
    async getRooms() {
      try {
        const res = await axios.get("/rooms");
        this.rooms = res.data.data || [];
      } catch (error) {
        console.error("Failed to fetch rooms:", error);
      }
    },
    async getData() {
      this.isLoading = true;
      const query = new URLSearchParams({
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        search_keyword: this.filter.search_keyword || "",
        is_active: this.filter.is_active || "",
        room_id: this.filter.room_id || "",
        show_deleted: this.isDeletePage() ? 1 : 0,
      }).toString();
      try {
        const res = await axios.get(`/room_notifications?${query}`);
        this.notifications = res.data.data;
        this.paginationLength = Math.ceil(res.data.count / this.rowsPerPage);
      } catch (err) {
        console.error("Error fetching notifications:", err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
